<template>
    <base-modal-confirm
        :show-modal="showModal"
        :modal-heading="$t('NOT_AVAILABLE_HEADER')"
        :modal-copy="$t('NOT_AVAILABLE_BODY')"
        :cta-copy="$t('OK')"
        :show-cancel="false"
        :show-confirm="false"
    />
</template>

<script>
    import BaseModalConfirm from './BaseModalConfirm.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            BaseModalConfirm,
        },

        data() {
            return {};
        },

        computed: {
            showModal() {
                return this.customizerStore.notAvailable;
            },
        },

        methods: {
        },
    };
</script>
